import * as React from 'react'
import { getForgotPasswordAbsoluteLink } from '../util/getForgotPasswordAbsoluteLink'
import { AuthState } from '../types/AuthState'

type ForgotPasswordLinkPropsType = {
  authState?: AuthState
  text?: string
  email: string
  color?: string
  rawText?: boolean
}

const defaultText = 'Forgot password?'

const ForgotPasswordLink = ({
  authState,
  email,
  text = defaultText,
  rawText = false,
  color = '',
}: ForgotPasswordLinkPropsType): JSX.Element => {
  const resetPasswordUrl = getForgotPasswordAbsoluteLink({
    login: email || authState?.assetNotes?.login_hint,
    clientId: authState?.cid,
  })

  return (
    <a href={resetPasswordUrl} target="_self" className="link link-inline" style={{ color }}>
      {rawText ? text : <small>{text}</small>}
    </a>
  )
}

ForgotPasswordLink.defaultProps = {
  text: defaultText,
  email: null,
  rawText: false,
}

export default ForgotPasswordLink
